module.exports = __webpack_public_path__ + "img/img_character.781a4350.svg";